module.exports = __webpack_public_path__ + "static/media/ico_order_settings.aad3bb29.svg";